module.exports = __webpack_public_path__ + "img/292922.7bf55f12.svg";